import React, { useState } from 'react';
import Button from 'components/Button';
import TextField from 'components/TextField';
import Section from '../../components/Section';
import ModalSelecionarVeiculo from './ModalSelecionarVeiculo';
import ModalSelecionarCondutor from './ModalSelecionarCondutor';
import { Container, FieldLabel, Row, Column, WrapperInputCustom } from './styles';

function Rodoviario({ formik, edit, view }) {
  const [showModalVeiculo, setShowModalVeiculo] = useState(false);
  const [showModalCondutor, setShowModalCondutor] = useState(false);

  const handleSelectVeiculo = (veiculo) => {
    const veiculos = formik.values.veiculos || [];
    // Verificar se já existe pelo ID ou pela combinação placa + motorista_cpf
    const veiculoId = veiculo.id || `${veiculo.placa}_${veiculo.motorista_cpf}`;
    const exists = veiculos.some((v) => {
      const vId = v.id || `${v.placa}_${v.motorista_cpf}`;
      return vId === veiculoId;
    });
    if (!exists) {
      formik.setFieldValue('veiculos', [...veiculos, veiculo]);
    }
  };

  const handleSelectCondutor = (condutor) => {
    const condutores = formik.values.condutores || [];
    const exists = condutores.some((c) => c.id === condutor.id || c.cpf === condutor.cpf);
    if (!exists) {
      // Garantir que o condutor tenha os campos necessários para o MDF-e
      const condutorFormatado = {
        id: condutor.id,
        nome: condutor.nome,
        cpf: condutor.cpf,
        cnh: condutor.cnh,
        categoria_cnh: condutor.categoria_cnh
      };
      formik.setFieldValue('condutores', [...condutores, condutorFormatado]);
    }
  };

  return (
    <Section title="Rodoviário">
      <Container>
        <Row>
          <Column>
            <WrapperInputCustom>
              <TextField
                label="Tipo Transportador"
                name="transport_type"
                value={formik.values.transport_type || 'tac'}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.transport_type && Boolean(formik.errors.transport_type)}
                helperText={formik.touched.transport_type && formik.errors.transport_type}
                disabled={view}
                select
                fullWidth
                color="secondary"
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <option value="tac">TAC</option>
                <option value="etc">ETC</option>
                <option value="ctc">CTC</option>
              </TextField>
            </WrapperInputCustom>
          </Column>

          <Column>
            <WrapperInputCustom>
              <TextField
                label="RNTRC"
                name="rntrc"
                placeholder="Registro Nacional de Transportadores Rodoviários de Carga"
                value={formik.values.rntrc || ''}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.rntrc && Boolean(formik.errors.rntrc)}
                helperText={formik.touched.rntrc && formik.errors.rntrc}
                disabled={view}
                fullWidth
                color="secondary"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </WrapperInputCustom>
          </Column>

          <Column>
            <WrapperInputCustom>
              <TextField
                label="CIOT"
                name="ciot"
                placeholder="Código Identificador da Operação de Transporte"
                value={formik.values.ciot || ''}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={view}
                fullWidth
                color="secondary"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </WrapperInputCustom>
          </Column>
        </Row>

        <Row>
          <WrapperInputCustom>
            <Button
              label="+ Adicionar Veículo"
              onClick={() => setShowModalVeiculo(true)}
              type="secondary"
              width="180px"
              height="40px"
            />
          </WrapperInputCustom>

          <WrapperInputCustom>
            <Button
              label="+ Adicionar Condutor"
              onClick={() => setShowModalCondutor(true)}
              type="secondary"
              width="180px"
              height="40px"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </WrapperInputCustom>
        </Row>

        {/* Lista de veículos adicionados */}
        {formik.values.veiculos && formik.values.veiculos.length > 0 && (
          <Row>
            <div style={{ width: '100%', marginTop: '20px' }}>
              <FieldLabel>Veículos Adicionados</FieldLabel>
              {formik.values.veiculos.map((veiculo, index) => (
                <div
                  key={index}
                  style={{
                    padding: '10px',
                    margin: '5px 0',
                    background: '#f5f5f5',
                    borderRadius: '4px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span>
                    <strong>{veiculo.placa}</strong> - {veiculo.renavam || 'N/A'} 
                    {veiculo.tipo && `(${veiculo.tipo === 'tração' ? 'Tração' : 'Reboque'})`}
                    {veiculo.motorista_nome && ` - Motorista: ${veiculo.motorista_nome}`}
                  </span>
                  <button
                    type="button"
                    onClick={() => {
                      const newVeiculos = formik.values.veiculos.filter(
                        (_, i) => i !== index
                      );
                      formik.setFieldValue('veiculos', newVeiculos);
                    }}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: '#f27160',
                      cursor: 'pointer',
                    }}
                  >
                    Remover
                  </button>
                </div>
              ))}
            </div>
          </Row>
        )}

        {/* Lista de condutores adicionados */}
        {formik.values.condutores && formik.values.condutores.length > 0 && (
          <Row>
            <div style={{ width: '100%', marginTop: '20px' }}>
              <FieldLabel>Condutores Adicionados</FieldLabel>
              {formik.values.condutores.map((condutor, index) => (
                <div
                  key={index}
                  style={{
                    padding: '10px',
                    margin: '5px 0',
                    background: '#f5f5f5',
                    borderRadius: '4px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span>
                    <strong>{condutor.nome}</strong> - CPF: {condutor.cpf || 'N/A'}
                    {condutor.cnh && ` - CNH: ${condutor.cnh}`}
                    {condutor.categoria_cnh && ` (${condutor.categoria_cnh})`}
                  </span>
                  <button
                    type="button"
                    onClick={() => {
                      const newCondutores = formik.values.condutores.filter(
                        (_, i) => i !== index
                      );
                      formik.setFieldValue('condutores', newCondutores);
                    }}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: '#f27160',
                      cursor: 'pointer',
                    }}
                  >
                    Remover
                  </button>
                </div>
              ))}
            </div>
          </Row>
        )}

        <ModalSelecionarVeiculo
          open={showModalVeiculo}
          onClose={() => setShowModalVeiculo(false)}
          onSelect={handleSelectVeiculo}
        />

        <ModalSelecionarCondutor
          open={showModalCondutor}
          onClose={() => setShowModalCondutor(false)}
          onSelect={handleSelectCondutor}
        />
      </Container>
    </Section>
  );
}

export default Rodoviario;

